// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2feb946b","453":"dddc87de","455":"88e8041f"}[chunkId] + ".chunk.js";
};